import React, { PureComponent } from 'react';
import { wire } from 'react-hot-wire';
import { isEmpty } from 'lodash';

import Register from './Register.template';
import registerIntegrations from './integrations';

import { Integration } from 'components/auth/Integration';
import OAuthIntegration from 'models/application/integration/OAuthIntegration';
import Logo from '../Logo';
import LanguageSwitcher from 'components/auth/LanguageSwitcher';

export class RegisterComponent extends PureComponent {
	render() {
		return (
			<div className="integrations integrations__register">
				<div className="content">
					<LanguageSwitcher containerClassName="auth top-right" />
					<Logo />
					{this._view()}
				</div>
			</div>
		);
	}

	_view() {
		const integrations = this.props['services.applicationService'].applicationConfig().integrations();
		const { params } = this.props;

		if (params && params.id) {
			return Integration(registerIntegrations, integrations.get(params.id));
		}

		return (
			<Register
				OAuthIntegrations={integrations.registerIntegrations.filter(
					integration => integration instanceof OAuthIntegration
				)}
				otherIntegrations={integrations.registerIntegrations.filter(
					integration => !(integration instanceof OAuthIntegration)
				)}
				loginEnabled={!isEmpty(integrations.loginIntegrations)}
			/>
		);
	}
}

export default wire(['services.applicationService'], RegisterComponent);
